<ng-template #searchListTemplate let-searchTemplateShown="searchTemplateShown">
  @if (searchTemplateShown) {
    <div class="search-content">
      @if (!loadingSearches) {
        @if (tabId==='recent' && !!savedSearchesData.list && !!savedSearchesData.list.length) {
          <li role="button" id="edx_clearall" tabindex="6" (click)="clearRecent($event)" (keyup.enter)="clearRecent($event)" (keyup.space)="clearRecent($event)">
            <img class="search-icon" src="assets/images/formfield_clear.svg">
            <div class="text clear">{{this.localizer.getTranslation('FORMS.BUTTONS.CLEAR_ALL')}}</div>
          </li>
        }
        @for (search of savedSearchesData.list; track search; let i = $index) {
          <li class="searchitem" tabindex="6" [title]="search.DESCRIPTION" id="{{getMenuId(search)}}" (keyup.arrowup)="onKeyUp(savedSearchesData.list,$event,i)" (keyup.arrowdown)="onKeyUp(savedSearchesData.list,$event,i)" (click)="executeSearch(search, $event)" (keyup.enter)="executeSearch(search, $event)" (keyup.space)="executeSearch(search, $event)">
            @if (search['UNSAVED']!=='Y') {
              <img class="search-icon" src="assets/images/mime_saved_search.svg" alt="{{this.localizer.getTranslation('ALT_TEXT.SAVED_SEARCH')}}">
            }
            @if (search['UNSAVED']==='Y') {
              <img class="search-icon" src="assets/images/mime_unsaved_search.svg" alt="{{this.localizer.getTranslation('ALT_TEXT.UNSAVED_SEARCH')}}">
            }
            <div class="text">{{search.DESCRIPTION}}</div>
          </li>
        }
        @if (!loadingSearches && (!savedSearchesData.list || !savedSearchesData.list.length)) {
          <li class="searchitem">
            <div class="text center" tabindex="6">{{this.localizer.getTranslation('HERO.SECTIONS.NO_ITEMS')}}</div>
          </li>
        }
      }
      @if (loadingSearches) {
        <edx-spinner class="spinner" [mini]="true"></edx-spinner>
      }
    </div>
  }
</ng-template>

<ng-template #optionsTemplate let-optionsTemplateShown="optionsTemplateShown">
  @if (optionsTemplateShown) {
    <div class="searchheader" [ngClass]="{first: !mobile}">
      <div class="search-title" tabindex="6" (keydown.shift.tab)="shiftFocusToSavedTab($event)">{{this.localizer.getTranslation('GLOBAL_SEARCHSCOPE.SEARCH_SCOPE')}}</div>
    </div>
    @for (item of items; track item; let i = $index) {
      <li role="menuitemcheckbox" [attr.aria-checked]="item.checked" class="searchitem" id="{{getMenuId(item)}}" class="{separator:item.separator, hidden:!item.enabled}" tabindex="6" (click)="execute(items.indexOf(item), $event)" (keyup.arrowup)="onKeyUp(items,$event,i)" (keyup.arrowdown)="onKeyUp(items,$event,i)" (keyup.arrowup)="onKeyUp($event,i)" (keyup.enter)="execute(items.indexOf(item), $event)" (keyup.space)="execute(items.indexOf(item), $event)">
        @if (item.checkable) {
          <div class="checkmark" [ngClass]="{checked:item.checked}" (click)="execute(items.indexOf(item), $event)"></div>
        }
        <div class="text">{{item.name}}</div>
      </li>
    }
    <div class="searchheader">
      <div class="search-title" tabindex="6">{{this.localizer.getTranslation('GLOBAL_SEARCHSCOPE.MORE_SEARCHES')}}</div>
    </div>
    @for (item of moreSearches; track item; let i = $index) {
      <li role="link" class="searchitem" >
        <div class="checkmark"></div>
        <div id="{{getMenuId(item)}}" class="text" [ngClass]="{link: item.isLink, graytext: !item.isLink}" tabindex="6" (click)="doCommand(item.id, item)" (keyup.enter)="doCommand(item.id, item)" (keyup.space)="doCommand(item.id, item)" (keyup.arrowup)="onKeyUp(moreSearches,$event,i)" (keyup.arrowdown)="onKeyUp(moreSearches,$event,i)">{{item.resource}}</div>
      </li>
    }
    <div class="searchheader">
      <div class="search-title" tabindex="6">{{this.localizer.getTranslation('GLOBAL_SEARCHSCOPE.LIBRARIES_TO_SEARCH')}}</div>
    </div>
    <div id="librariesList" class="libraries-list">
      @for (item of libraries; track item; let index = $index) {
        @if (item.DISABLED!=='Y') {
          <li class="searchitem" (keyup.enter)="doCommand('libraries', item)" (keyup.arrowup)="onKeyUp(libraries,$event,index)" (keyup.arrowdown)="onKeyUp(libraries,$event,index)"(keyup.space)="doCommand('libraries', item)" (keydown.tab)="onTab($event,index)" (keydown.shift.tab)="onTab($event,index)">
            <input type="checkbox" [id]="item.LIBRARY_NAME" (click)="doCommand('libraries', item)" class="checkbox" [ngClass]="{checked: item.checked}">
            <span for id="{{getMenuId(item)}}" class="text lib-text" role="checkbox" tabindex="6" [attr.aria-checked]="item.checked" (click)="doCommand('libraries', item)" [attr.aria-label]="isChrome?(item.checked?item.LIBRARY_NAME+' ':item.LIBRARY_NAME):item.LIBRARY_NAME">{{item.LIBRARY_NAME}} </span>
          </li>
        }
      }
    </div>
  }
</ng-template>

<div class="menubutton menubuttonsearch" id="edx_search_menu" [attr.aria-expanded]="isOpen" role="button" title="{{this.localizer.getTranslation('ALT_TEXT.SEARCH_MENU')}}" attr.aria-label ="{{this.localizer.getTranslation('ALT_TEXT.SEARCH_MENU') + ' '+ (isOpen?altLabels['expanded']:altLabels['collapsed'])}}" [ngClass]="{mobile: mobile}" tabindex="6" (click)="toggleMenuOpen($event)" (keyup.enter)="toggleMenuOpen($event)" (keyup.arrowdown)="toggleMenuOpen($event)" (keyup.space)="toggleMenuOpen($event)" (keydown.escape)="closeMenu(false)" (keydown.shift.tab)="closeMenu(false)">
  <div class="dropdowncaret" [ngClass]="{rotateIcon:isOpen}" title="{{this.localizer.getTranslation('TOOLTIP.SEARCH_OPTIONS')}}"></div>
  @if (isOpen) {
    <div class="menublocker" [ngClass]="{blocktop:drawUp, blockright:drawToRight}"></div>
  }
</div>
@if (isOpen) {
  <div class="menu-overlay" (click)="overlayClick($event)"></div>
}
@if (isOpen) {
  <ul role="menu" class="search-dropdown" [ngClass]="{opening: isOpening, closing: isClosing, drawright: drawToRight, drawup: drawUp, mobile: mobile, adjust: adjust}"
    (animationend)="transitionComplete()" (keyup.escape)="closeMenu(false)">
    <div class="leftbody" role="menuitem">
      <div class="tabcontainer">
        <edx-tab-selector #tabSelector [receiver]="this" [tabIndex]="6" [tabdefs]="tabList"></edx-tab-selector>
      </div>
      <div class="dropdown">
        @switch (tabId) {
          @case ('recent') {
            <ng-container *ngTemplateOutlet="searchListTemplate;context:{searchTemplateShown:true}"></ng-container>
          }
          @case ('saved') {
            <ng-container *ngTemplateOutlet="searchListTemplate;context:{searchTemplateShown:true}"></ng-container>
          }
          @case ('options') {
            <ng-container *ngTemplateOutlet="optionsTemplate;context:{optionsTemplateShown:true}"></ng-container>
          }
        }
      </div>
    </div>
    @if (!mobile) {
      <div class="rightbody" role="menuitem">
        <div class="dropdown">
          <ng-container *ngTemplateOutlet="optionsTemplate;context:{optionsTemplateShown:true}"></ng-container>
        </div>
      </div>
    }
  </ul>
}
